import React from "react";
import { Edit, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from "react-admin";
import { Permission } from "../../components";
import { PERMISSIONS } from "../../constants";

const CityEdit = () => (
  <Edit title="Editar cidade">
    <SimpleForm sx={{ maxWidth: 600 }}>
      {Permission({
        permission: PERMISSIONS.ADMIN,
        children: (
          <ReferenceInput
            reference="chains"
            source="chainId"
            style={{ minWidth: 220 }}
            sort={{ field: 'name', order: 'ASC' }}
            //@ts-ignore
            perPage={false}
          >
            <SelectInput
              sx={{ minWidth: 300 }}
              label="Rede"
              optionText="name"
              disabled
            />
          </ReferenceInput>
        )
      })}
      <TextInput sx={{ minWidth: 300 }} source="name" label="Nome" validate={required()} />
    </SimpleForm>
  </Edit>
);

export default CityEdit;
